import React from 'react';

interface AlertWarningProps {
  children: React.ReactNode;
}

export const AlertWarning: React.FunctionComponent<AlertWarningProps> = ({ children }) => {
  return <div className="alert alert-warning mr10 ml10 pt8 pb6">{children}</div>;
};
